module.exports = __webpack_public_path__ + "img/hospitium-08.9ac16179.jpg";